import { TypographyH3, TypographyP } from '@talentmesh/ui/components/typography';
import React from 'react';

export interface ProfileGroupFormProps {
    dataCy?: string;
    title: string;
    description: string;
    width?: string;
}

export default function ProfileGroupForm({
    dataCy,
    title,
    description,
    width,
    children,
}: React.PropsWithChildren<ProfileGroupFormProps>) {
    return (
        <div data-cy={dataCy} className="flex flex-col gap-2" style={{ width }}>
            <TypographyH3>{title}</TypographyH3>
            <TypographyP>{description}</TypographyP>
            {children}
        </div>
    );
}
